var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-vjs-player":""}},[_c('video',{ref:"myPlayer",class:("" + _vm.className),attrs:{"poster":_vm.poster}})])}
var staticRenderFns = []

export { render, staticRenderFns }